/**
 * Selection highlight as a soft glow in the item's OWN colour, replacing the flat
 * accent-ring we used to draw around selected cards/avatars. A crisp ~1.5px edge
 * keeps the selection legible, and a balanced ~22px bloom gives it life.
 *
 * `color-mix` is used for the bloom so any colour format works (hex, rgb(),
 * CSS var) — important because callers pass domain colours, theme primaries, etc.
 *
 * @param color any CSS colour the item is themed with
 * @param strength bloom emphasis: 'subtle' | 'balanced' (default) | 'prominent'
 */
export function selectionGlow(
  color: string,
  strength: 'subtle' | 'balanced' | 'prominent' = 'balanced',
): string {
  const edge = strength === 'subtle' ? '0 0 0 0px' : '0 0 0 1.5px';
  const bloom =
    strength === 'subtle' ? '0 0 16px 1px' : strength === 'prominent' ? '0 0 30px 4px' : '0 0 22px 2px';
  const bloomAlpha = strength === 'prominent' ? 60 : 45;
  return `${edge} ${color}, ${bloom} color-mix(in srgb, ${color} ${bloomAlpha}%, transparent)`;
}
